export default {
  select: 'Обрати мітки...'
};
